import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../opinion-on-issuing-a-decision.routes';
import {
  OpinionOnIssuingADecisionApplicationDataForm
} from './forms/opinion-on-issuing-a-decision-application-data.form';
import {
  createApplication,
  setApplication,
  updateApplication
} from '../../../../../../store/actions/application.actions';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ApplicationAppEntityApplicationRead, DocumentReceiptMethodAppEntityDictionaryDocumentReceiptMethod,
  DocumentReceiptMethodService, ServiceAppEntityServiceRead
} from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { selectServiceByUrl } from '../../../../../../store/selectors/app.selectors';
import {
  ExposedMapControlComponent
} from '../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { UserDetails } from '../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../store/selectors/user-details.selectors';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-application-data',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    ExposedMapControlComponent
  ],
  providers: [
    OpinionOnIssuingADecisionApplicationDataForm
  ],
  templateUrl: './opinion-on-issuing-a-decision-application-data.component.html'
})
export class OpinionOnIssuingADecisionApplicationDataComponent implements OnDestroy {

  public stages: string[] = stages;

  public form: OpinionOnIssuingADecisionApplicationDataForm = inject(OpinionOnIssuingADecisionApplicationDataForm);

  private store$: Store = inject(Store);

  private router: Router = inject(Router);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private applicationId: string = this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public serviceType: Signal<ServiceAppEntityServiceRead | null> = this.store$.selectSignal(selectServiceByUrl('opinia-w-sprawie-wydania-decyzji'));

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private documentReceiptMethodService: DocumentReceiptMethodService = inject(DocumentReceiptMethodService);

  public methods: Signal<DocumentReceiptMethodAppEntityDictionaryDocumentReceiptMethod[] | undefined> = toSignal(this.documentReceiptMethodService.getDocumentReceiptMethodCollectionDocumentReceiptMethodCollection({
    pagination: false
  }));

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.store$.dispatch(updateApplication({
          id: this.applicationId || '',
          application: this.form.toWriteModel(),
          successFnc: (applicationId) => {
            this.router.navigate(
              ['../../', applicationId, 'inwestor'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        }));
      } else {
        this.store$.dispatch(createApplication({
          serviceTypeId: this.serviceType()?.uuid || '',
          application: this.form.toWriteModel(),
          applicants: [
            {
              id: '',
              applicant: {
                entityType: '14115421-88f2-431a-8310-203c68180b33',
                firstName: this.user()?.firstName || '',
                lastName: this.user()?.lastName || '',
                email: this.user()?.email || ''
              }
            }
          ],
          successFnc: (applicationId) => {
            this.router.navigate(
              ['../', applicationId, 'inwestor'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        }));
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate([this.applicationId ? '../../../' : '../../'], { relativeTo: this.route })
      .then(() => this.store$.dispatch(setApplication({ application: null })));
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
